import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import DeleteForm from '../forms/delete-form';
import { deleteValidationSchema } from '../schema/delete.js';

export default function DeleteNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Delete Node Details',
        altText: 'Delete Node',
        defaultLabel: data?.command || 'Delete Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={DeleteForm} schemaResolver={deleteValidationSchema} />
    </NodeProvider>
  );
}
